export const iconFontAwesomeDisasterCrisisXmarksLines = (
	<i className="fa-solid fa-xmarks-lines"></i>
);
